module.exports = __webpack_public_path__ + "static/media/star_full.545e5916.png";